(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/jackpot-header/assets/javascripts/jackpot-header.js') >= 0) return;  svs.modules.push('/components/tur/jackpot-header/assets/javascripts/jackpot-header.js');
"use strict";



svs.tur = svs.tur || {};
svs.tur.JackpotHeader = class JackpotHeader {
  constructor() {
    let autoHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let logoAtBottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.el = document.getElementsByClassName('js-jackpot-header')[0];
    if (!this.el) {
      return {};
    }
    this.elContent = this.el.getElementsByClassName('js-jackpot-header-content')[0];
    this.elContentJackpot = this.el.getElementsByClassName('jackpot-header-jackpot')[0];
    this.elLogo = this.el.getElementsByClassName('js-jackpot-header-logo')[0];
    this.elBg = this.el.getElementsByClassName('js-jackpot-header-background')[0];
    this.overlay = document.getElementsByClassName('js-jackpot-header-overlay')[0];
    this.headerLogo = window.getComputedStyle(document.getElementsByClassName('header-row-logo')[0]).display !== 'none' ? document.getElementsByClassName('header-row-logo')[0] : document.getElementsByClassName('header-row-logo')[1];
    this.img = document.getElementsByClassName('jackpot-header-img')[0];
    this.navBreakPoint = 1357;
    this.hasMenuOnTop = window.innerWidth > this.navBreakPoint && document.body.classList.contains('nav-top');
    if (this.elContentJackpot) {
      this.elContentJackpot.innerHTML = this.elContentJackpot.innerHTML.replace(/(\w+\s+\w+\s+\w+?)$/, '<span>$1</span>');
    }
    if (svs.core.detect.formfactor.mobile()) {
      this.corpInfo = document.getElementsByClassName('corporate-info-legal-info')[0];
    } else {
      this.corpInfo = document.getElementsByClassName('corporate-info-ao-brand-content')[0];
    }
    if (document.getElementsByClassName('corporate-info-small').length) {
      this.corpInfo = null;
    }
    document.getElementsByClassName('js-top-center-content')[0].addEventListener('click', e => {
      e.preventDefault();
      this.show();
    });
    this.overlay.addEventListener('click', () => {
      this.hide();
    });
    this.el.addEventListener('click', () => {
      this.hide();
    });
    if (logoAtBottom) {
      this.setupAnimationsLogoBottom();
    } else {
      this.setupAnimationsDefault();
    }
    if (this.el.classList.contains('transparent')) {
      this.el.classList.remove('transparent');
      this.overlay.classList.remove('transparent');
      this.tl.seek(-1, false);
    } else if (autoHide) {
      if (this.corpInfo) {
        this.onCorpAnimationEnd = this.onCorpAnimationEnd.bind(this);
        this.corpInfo.addEventListener('animationend', this.onCorpAnimationEnd, false);
      } else {
        setTimeout(() => this.hide(), 1100);
      }
    }
  }
  onCorpAnimationEnd() {
    setTimeout(() => this.hide(), 0);
  }
  show() {
    this.tl.play().timeScale(1);
  }
  hide() {
    this.corpInfo && this.corpInfo.removeEventListener('animationend', this.onCorpAnimationEnd, false);
    !this.tl.isActive() && this.tl.reverse().timeScale(-1.5);
  }
  setupAnimationsDefault() {
    const logoScale = this.hasMenuOnTop ? 0.7 : 0.48,
      logoY = this.hasMenuOnTop ? -48 : -52,
      headerLogoScale = this.hasMenuOnTop ? 0.8 : 0.6;
    this.tl = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.el.classList.remove('force-hide');
        svs.events.publish('jackpotheader/show');
      },
      onReverseComplete: () => {
        this.el.classList.add('force-hide');
        this.el.classList.remove('jackpot-header-init');
        new gsap.fromTo(this.headerLogo, 2, {
          ease: Back.easeOut,
          scale: headerLogoScale
        }, {
          ease: Elastic.easeOut.config(1, 0.1),
          scale: 1
        });
        svs.events.publish('jackpotheader/hide');
      }
    });
    this.tl.add(new gsap.fromTo(this.elLogo, 0.7, {
      ease: Elastic.easeOut.config(1, 0.5),
      y: logoY,
      scale: logoScale,
      autoAlpha: 1
    }, {
      ease: Elastic.easeOut.config(1, 0.5),
      y: 0,
      scale: 1,
      autoAlpha: 1
    }));
    this.tl.add(new gsap.fromTo(this.elBg, 0.1, {
      ease: Back.easeIn,
      height: 44,
      width: 0,
      autoAlpha: 0
    }, {
      ease: Back.easeOut,
      width: '140%',
      height: 44,
      autoAlpha: 1
    }), 0);
    this.tl.add(new gsap.to(this.elBg, 0.8, {
      ease: Elastic.easeOut.config(1, 0.5),
      width: '140%',
      height: '300%',
      autoAlpha: 1
    }), 0);
    this.tl.add(new gsap.fromTo(this.elContent, 0.25, {
      ease: Elastic.easeOut.config(1, 0.5),
      y: -20,
      autoAlpha: 0
    }, {
      ease: Elastic.easeOut.config(1, 0.5),
      y: 0,
      autoAlpha: 1
    }), 0.3);
    this.tl.add(new gsap.fromTo(this.overlay, 0.25, {
      autoAlpha: 0
    }, {
      autoAlpha: 1
    }), '-=.7');
    this.tl.progress(1, false);
  }
  setupAnimationsLogoBottom() {
    const headerLogoScale = this.hasMenuOnTop ? 0.8 : 0.6;
    this.tl = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.el.classList.remove('force-hide');
        svs.events.publish('jackpotheader/show');
      },
      onReverseComplete: () => {
        this.el.classList.add('force-hide');
        this.el.classList.remove('jackpot-header-init');
        new gsap.fromTo(this.headerLogo, 2, {
          ease: Back.easeOut,
          scale: headerLogoScale
        }, {
          ease: Elastic.easeOut.config(1, 0.1),
          scale: 1
        });
        svs.events.publish('jackpotheader/hide');
      }
    });
    this.tl.add(new gsap.fromTo(this.elLogo, 0.7, {
      ease: Elastic.easeOut.config(1, 0.8),
      y: -250
    }, {
      ease: Elastic.easeOut.config(1, 0.8),
      y: 0
    }));
    if (this.img) {
      this.tl.add(new gsap.fromTo(this.img, 0.7, {
        ease: Elastic.easeOut.config(1, 0.7),
        y: -200
      }, {
        ease: Elastic.easeOut.config(1, 0.7),
        y: 0
      }), '-=.6');
    }
    this.tl.add(new gsap.fromTo(this.elBg, 0.1, {
      ease: Back.easeIn,
      height: 44,
      width: 0,
      autoAlpha: 0
    }, {
      ease: Back.easeOut,
      width: '140%',
      height: 44,
      autoAlpha: 1
    }), 0);
    this.tl.add(new gsap.to(this.elBg, 0.8, {
      ease: Elastic.easeOut.config(1, 0.5),
      width: '140%',
      height: '300%',
      autoAlpha: 1
    }), 0);
    this.tl.add(new gsap.fromTo(this.elContent, 0.45, {
      ease: Elastic.easeOut.config(1, 0.5),
      y: -50,
      autoAlpha: 0
    }, {
      ease: Elastic.easeOut.config(1, 0.5),
      y: 0,
      autoAlpha: 1
    }), 0.3);
    this.tl.add(new gsap.fromTo(this.overlay, 0.25, {
      autoAlpha: 0
    }, {
      autoAlpha: 1
    }), '-=.9');
    this.tl.progress(1, false);
  }
  static isVisible() {
    const el = document.getElementsByClassName('js-jackpot-header')[0];
    return el && !el.classList.contains('force-hide');
  }
  destroy() {
    this.tl.kill();
    if (this.el.remove) {
      this.el.remove();
      this.overlay.remove();
    } else {
      this.el.classList.add('force-hide');
      this.overlay.classList.add('force-hide');
    }
  }
};

 })(window);